import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {TicketConfiguration} from '../../Models';
import {VuexObjectMixin} from '../../Mixins';

@Component({})
export default class Vvs extends VuexObjectMixin {
  @Prop({type: TicketConfiguration, required: false}) ticketConfiguration: TicketConfiguration | undefined;

  get showIcon(): boolean {
    if (!this.ticketConfiguration) {
      return true;
    }
    let showIcon = false;
    if (this.ticketConfiguration.product.localPubTransIncluded === 1) {
      showIcon = true;
      if (this.ticketConfiguration.isAdditionalProduct) {
        showIcon = false;
        const eventId = this.ticketConfiguration.event.id;
        if (this.cart?.order) {
          this.cart.order.additionalOrderItemConfigurations.forEach((aoic) => {
            const product = aoic.getProduct();
            if (product && product.price > 0 && product.eventId === eventId && product.localPubTransIncluded === 1) {
              showIcon = true;
            }
          });
        }
      }
    }
    return showIcon;
  }

}
